import { axios } from '../configs';
import type {
  TFriendAnalyticsCollectResult,
  TFriendAnalyticsDaily,
  TFriendAnalyticsOverview,
  TFriendDemographics,
} from 'types/friendAnalytics';

export type TGetFriendAnalyticsDailyParams = {
  from: string;
  to: string;
};

export const getFriendAnalyticsOverview =
  async (): Promise<TFriendAnalyticsOverview> => {
    const res = await axios.get<TFriendAnalyticsOverview>(
      'line/friend-analytics/overview',
    );
    return res.data;
  };

export const getFriendAnalyticsDaily = async (
  params: TGetFriendAnalyticsDailyParams,
): Promise<TFriendAnalyticsDaily> => {
  const res = await axios.get<TFriendAnalyticsDaily>(
    'line/friend-analytics/daily',
    { params },
  );
  return res.data;
};

/** 自組織のLINE公式アカウントの欠損日を、1リクエストに収まる範囲で取得して保存する。 */
export const collectFriendAnalytics =
  async (): Promise<TFriendAnalyticsCollectResult> => {
    const res = await axios.post<TFriendAnalyticsCollectResult>(
      'line/friend-analytics/collect',
    );
    return res.data;
  };

export const getFriendDemographics = async (): Promise<TFriendDemographics> => {
  const res = await axios.get<TFriendDemographics>('line/friend-analytics/demographics');
  return res.data;
};
